/**
 * String xor crypt.
 * @param {String} str - String to decrypt.
 * @param {*} key - Key necessary for decrypting.
 */
const xorCrypt = (str, key) => {
  const chars = str.split('');
  const decodedChars = chars.map((char) => String.fromCharCode(key ^ char.charCodeAt()));

  return decodedChars.join('');
};

export { xorCrypt };
